import { Row, Typography } from "@commonlibs";
import { DayRoot } from "./WeeklySchedule.styles";
import { useState } from "react";
import { SchedulingTypeChildProps } from "../../SchedulingTypeGroup";
import { Day, days } from "ui/common/utils/dateUtils";

export default function WeeklySchedule({ onChange }: SchedulingTypeChildProps) {

    const [selectedDay, setSelectedDay] = useState<Day>(days[0]);

    function onSelectDay(day: Day) {
        setSelectedDay(day);
        onChange?.(day.value);
    }

    return (
        <Row gap={4}>
            {days.map((item) => (
                <DayRoot key={item.value} onClick={() => onSelectDay(item)} selected={selectedDay.value === item.value}>
                    <Typography variant="body3Regular">{item.label}</Typography>
                </DayRoot>
            ))}
        </Row>
    );
}
